export default {"src":"/_next/static/media/logo-black.5173c420.svg","height":102,"width":300,"blurWidth":0,"blurHeight":0};